import { apiClient } from "lib/apiClient";
import { IMarketAreasInfo, MarketAreaStatus } from "features/MarketAreas/types";
import { SORT_DIRECTIONS_ENUM } from "config/constants";

export interface IGetMarketAreasParams {
  status?: MarketAreaStatus;
  name?: string;
  sortField?: string | null;
  sortOrder?: SORT_DIRECTIONS_ENUM | null;
}

export const getMarketAreas = async (
  params: IGetMarketAreasParams = {},
  signal?: AbortSignal
): Promise<IMarketAreasInfo> => {
  const { status, name, sortField, sortOrder } = params;
  const sort = sortField
    ? `${sortField},${sortOrder ?? SORT_DIRECTIONS_ENUM.DESC}`
    : undefined;

  const response = await apiClient.get<IMarketAreasInfo>("/market-areas", {
    params: { status, name, sort, includePropertyCount: true },
    signal,
  });

  return response.data;
};
